const normalize = (value) => String(value || '').toLocaleLowerCase('is-IS').trim();

const TEAM_ALIASES = {
  'man utd': 'manchester united',
  'manu': 'manchester united',
  'man u': 'manchester united',
  'mu': 'manchester united',
  'mufc': 'manchester united',
  'barca': 'barcelona',
  'fcb': 'barcelona',
  'rma': 'real madrid',
  'atm': 'atletico madrid',
  'atletico': 'atletico madrid',
  'psg': 'paris saint germain',
  'juve': 'juventus',
  'bayern': 'bayern munchen',
  'bvb': 'borussia dortmund',
  'spurs': 'tottenham',
  'coys': 'tottenham',
  'lfc': 'liverpool',
  'mcfc': 'manchester city',
  'afc': 'arsenal',
  'cfc': 'chelsea',
};

function expandQuery(q) {
  const terms = [q];
  for (const [abbr, full] of Object.entries(TEAM_ALIASES)) {
    const a = normalize(abbr);
    // Exact alias match, or query is a prefix of an alias ("man ut" → "man utd")
    if (q === a || (q.length >= 3 && a.startsWith(q))) {
      terms.push(normalize(full));
    }
  }
  return terms;
}

export function searchScore(product, query) {
  const q = normalize(query);
  if (!q) return 0;

  const team = normalize(product.team);
  const name = normalize(product.name);
  const terms = expandQuery(q);

  // Exact team match (highest priority)
  if (terms.some(t => team === t)) return 100;

  // Name starts with query
  if (name.startsWith(q)) return 90;

  // Alias-expanded team match
  for (const t of terms) {
    if (t !== q && team.includes(t)) return 85;
  }

  // Team includes query
  if (team.includes(q)) return 80;

  // Name includes query or any expanded term
  for (const t of terms) {
    if (name.includes(t)) return 70;
  }

  return -1;
}

export function compareSearchResults(a, b, query) {
  const relevance = searchScore(b, query) - searchScore(a, query);
  return relevance || new Date(b.created_date) - new Date(a.created_date);
}